/**
 * `config.js`
 *  -  設定ファイル
 *
 * 使用方法:
 *  - import { config } from "../config.js";
 */

export const config = {
  mode: 'dev',                  // dev or prod
  domainProd: 'jcss-tax.com',   // 本番環境のドメイン
  useBarba: true,               // Barba.js を使うかどうか
  momentumScrolling: "lenis",   // "gsap" | "lenis" | "none"  (gsapはgsapScrollSmoother）
  useGsap: true,                // GSAP を使うかどうか
  useGsapScrollTrigger: true,   // GsapScrollTrigger を使うかどうか
  useThreeJS: false,            // Three.js を使うかどうか
  useSwiper: true,              // Swiper を使うかどうか（スライダー）
  useFlatpickr: true,           // Flatpickr を使うかどうか（日付選択モーダル）
  gaTagType: 'ga4',             // ga4 || gtm  GTMを使う場合は、GTM側のSPA設定を有効にするだけでOK。gaTagTypeをgtmにすることでJS側でのイベント送信を無効化できる。
  gaTagId:   'GTM-MQF88C7VCF',  // プロジェクトのGTM, GA4アカウント
  recaptchaPublicKey: '6LdpSposAAAAAAGwHpjjLjO_KtDgF05CFlTpiSvs',
};
